/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDefaultOrganizationSchema
 */
export interface UserDefaultOrganizationSchema {
    /**
     * 
     * @type {number}
     * @memberof UserDefaultOrganizationSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDefaultOrganizationSchema
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDefaultOrganizationSchema
     */
    isPersonal: boolean;
}

/**
 * Check if a given object implements the UserDefaultOrganizationSchema interface.
 */
export function instanceOfUserDefaultOrganizationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isPersonal" in value;

    return isInstance;
}

export function UserDefaultOrganizationSchemaFromJSON(json: any): UserDefaultOrganizationSchema {
    return UserDefaultOrganizationSchemaFromJSONTyped(json, false);
}

export function UserDefaultOrganizationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDefaultOrganizationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPersonal': json['is_personal'],
    };
}

export function UserDefaultOrganizationSchemaToJSON(value?: UserDefaultOrganizationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_personal': value.isPersonal,
    };
}

